import React, { Fragment } from 'react';
import hello from './hello.JPG';

function About() {

	// arrow on click
	const clickContinue = () => {
		// let nextSection = document.getElementById("researchSection");
		// nextSection.scrollIntoView();
		// window.location.href = "#researchSection";
		window.scrollBy(0, 500);
	}
	// I also investigate how to foster the skills (e.g., critical thinking and reasoning) necessary for identifying misinformation and data-based reasoning with the support of visualizations.

	return (
		<Fragment>
		<div class="aboutPage" id="aboutSection">
			<div class="homepage">
				<div>
					<img class="profile" src={hello} alt="profile"/>
				</div>
				
				<div class="about">
					{/*<h2 >Hello!</h2>*/}
					<p>Hello! I am a postdoc at Stanford with the <a target="_blank" rel="noopener noreferrer" href="https://cogtoolslab.github.io/">Cognitive Tools Lab</a>. I investigate how people read, create, and critically reason about visualizations. I am broadly interested in how we can better understand, measure, and improve reasoning and critical thinking in today’s information landscape, which allows me to engage in areas like human-computer interaction, information visualization, data science, cognitive psychology, and learning sciences.</p>
					<p>I earned my PhD in Computer Science at Northwestern University, where I was fortunate to have been advised by <a target="_blank" rel="noopener noreferrer" href="https://www.mjskay.com/">Matthew Kay</a>. My PhD work has been supported in part by the NSF Graduate Research Fellowship. Prior to Northwestern, I received my B.Sc. in Computer Science from the University of Michigan.</p>
				
					
					<div class="news">
						<h3>News</h3>
						<div class="news_scroll">
						<div class="info">
							<p><span role="img" aria-label="travel">&#128187;</span> I started as a postdoc at Stanford with the <a target="_blank" rel="noopener noreferrer" href="https://cogtoolslab.github.io/">Cognitive Tools Lab</a>! | Sep, 2026</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="travel">&#128747;</span> I co-organized a workshop: <a href="https://data-literacy-workshop.github.io/CHI26/">Data Literacy for the 21st Century: Perspectives from Visualization, Cognitive Science, Artificial Intelligence, and Education</a> at CHI 2026 in Barcelona | April, 2026 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I gave an invited talk on <i>Critical Thinking in Human-Data Interaction</i> at the symposium <a href="https://www.tfc.tohoku.ac.jp/event/4314.html">Approaching the World through the Lens of Causality</a> at Tohoku University, Japan | Feb, 2026 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I visited the Aviz team (Inria / LISN, University of Paris-Saclay) and gave a talk on  <a href="https://paris.sigchi.acm.org/">Critical Thinking in Human-Data Interaction</a> | Jan, 2026 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I gave an invited talk on visualization literacy at the <a href="https://indico.math.cnrs.fr/event/13124/">Rigorous Illustrations workshop</a> at the Institut Henri Poincaré in Paris, France | Jan, 2026 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I presented our paper <a href="https://mucollective.northwestern.edu/files/2025_vis_literacy_autoethnography.pdf">An Autoethnography on Visualization Literacy: A Wicked Measurement Problem</a> at VIS 2025 in Vienna, Austria | Nov, 2025 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="travel">&#128747;</span> I attended the selective <a href="https://nextprof.engin.umich.edu/nextprof-nexus/">NextProf Nexus 2025 workshop</a> hosted at the University of California, Berkeley | Sept, 2025 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I was an invited speaker at the <a href="https://nightingale-labs.github.io/">Nightingale Workshop</a> at Stanford University | July, 2025 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#128196;</span> Our paper <a href="https://osf.io/dfr4p_v2/"><i>An Autoethnography on Visualization Literacy: A Wicked Measurement Problem</i></a> got accepted to VIS 2025! | July, 2025</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I presented a poster on my thesis work at the <a href="https://www.grc.org/visualization-in-science-and-education-conference/2025/">Visualization in Science and Education Gordon Research Conference</a> | July, 2025 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I was invited to give a talk on <a href="https://mucollective.northwestern.edu/files/2024-V-FRAMER.pdf">V-FRAMER</a> at the <a href="https://www.grc.org/visualization-in-science-and-education-grs-conference/2025/">Visualization in Science and Education Gordon Research Seminar</a> | July, 2025 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="travel">&#128747;</span> I attended <a href="https://hcic.org/">HCIC 2025</a>! | June, 2025 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I presented our paper <a href="https://osf.io/preprints/osf/kz58f_v1">AVEC</a> at CHI 2025 | April, 2025 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I was invited to give talks on <i>Critical Thinking in Human-Data Interaction</i> at Fujitsu and Tohoku University, Japan | April, 2025 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#128196;</span> Our paper <a href="https://osf.io/preprints/osf/kz58f_v1"><i>AVEC: An Assessment of Visual Encoding Ability in Visualization Construction</i></a> got accepted to CHI 2025! | March, 2025</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I attended the doctoral colloquium at VIS 2024! | Oct. 2024 </p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#128196;</span> Our paper <a href="https://ieeexplore.ieee.org/abstract/document/10670418"><i>Promises and Pitfalls: Using Large Language Models to Generate Visualization Items</i></a> got accepted to VIS 2024! | July, 2024</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#127908;</span> I presented our paper <a href="https://mucollective.northwestern.edu/files/2024-V-FRAMER.pdf">V-FRAMER</a> and co-organized a <a href="https://visualization-literacy.github.io/CHI2024/">visualization literacy workshop</a> at CHI 2024! | May, 2024</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#128196;</span> Our paper <a href="https://mucollective.northwestern.edu/files/2024-V-FRAMER.pdf"><i>V-FRAMER: Visualization Framework for Mitigating Reasoning Errors in Public Policy</i></a> got accepted to CHI 2024! | March, 2024</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#128196;</span> Our paper <a href="https://lilyge.com/#researchSection"><i>Adaptive Assessment of Visualization Literacy</i></a> got accepted to VIS 2023! | July, 2023</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="intern">&#128105;&#8205;&#128187;</span> Research fellow in <a target="_blank" rel="noopener noreferrer" href="https://www.mccs.tohoku.ac.jp/g-rips/g-rips2023_en.html">G-RIPS-Sendai 2023</a> at Tohoku University, Japan! | June to August, 2023</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="travel">&#128747;</span> Attended <a target="_blank" rel="noopener noreferrer" href="https://chi2023.acm.org/">CHI 2023</a> at Hamburg, Germany! | April, 2023</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="travel">&#128747;</span> Attended the <a target="_blank" rel="noopener noreferrer" href="https://cra.org/cra-wp/grad-cohort-for-women/">2023 CRA-WP Grad Cohort Workshop for Women</a>! | April, 2023</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper_award">&#127881;</span> Our paper <a target="_blank" rel="noopener noreferrer" href="https://dl.acm.org/doi/abs/10.1145/3544548.3581406"><i>CALVI</i></a> got an Honorable Mention at CHI 2023! | April, 2023</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="award">&#127942;</span> Awarded the <a target="_blank" rel="noopener noreferrer" href="https://www.nsfgrfp.org/">National Science Foundation (NSF) Graduate Research Fellowship</a>! | March, 2023</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="paper">&#128196;</span> Our paper <a target="_blank" rel="noopener noreferrer" href="https://dl.acm.org/doi/abs/10.1145/3544548.3581406"><i>CALVI</i></a> got accepted to CHI 2023! | March, 2023</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="travel">&#128747;</span> Attended <a target="_blank" rel="noopener noreferrer" href="https://ieeevis.org/year/2022/welcome">IEEE VIS 2022</a> at Oklahoma City! | October, 2022</p>
						</div>
						<div class="info">
							<p><span role="img" aria-label="travel">&#128747;</span> Attended the <a target="_blank" rel="noopener noreferrer" href="https://cra.org/cra-wp/grad-cohort-for-women/">2022 CRA-WP Grad Cohort Workshop for Women</a>! | April, 2022</p>
						</div>
						</div>
					</div>
				</div>
				
			</div>
			<div class="continue" onClick={clickContinue}></div>
		</div>
		</Fragment>
	)
}

export { About }